import API from "../common/AxoisClient";
import { state_to_form_data } from "../helpers/UserHelper";
import { EmailTemplateModel } from "../model";

export class EmailTemplateService {

  static async get(id: number){
    const res = await API.get(`settings/email-templates/${id}`);
    return res.data
  }


  static async store(data: EmailTemplateModel) {
    const res = await API.post(`settings/email-templates`, (data));
    return res.data
  }

  static async update(data: EmailTemplateModel, id: number){
    const res = await API.post(`settings/email-templates/${id}`, ({...data, "_method": "put"}));
    return res.data
  }

  static async formData() {
    const res = await API.get(`settings/email-templates/form-data`);
    return res.data
  }
}